<template>
  <div class="main-in main-in1">
    <!-- pageshow-{{pageshow}}-isRouterAlive-{{isRouterAlive}} -->
    <div class="container home color-black " v-if='pageshow'>
      <div
        class="home-floating-inspection"
        v-if="showFloatingInspection"
        ref="inspectionFloat"
        :style="{ left: inspectionX + 'px', top: inspectionY + 'px' }"
      >
        <button
          class="home-floating-inspection-close"
          type="button"
          aria-label="关闭码上巡视"
          @click="closeInspectionFloat"
        >
          ×
        </button>
        <img
          class="home-floating-inspection-img"
          src="@/assets/img/index/code-Inspection.jpg"
          alt="码上巡视"
        />
      </div>
      <!-- box -->
      <div class="box f-row-start-l wrap">
        <div class="swiper">
          <div is="banner" :list="lunbo" v-if="lunbo.length > 0 && isRouterAlive"></div>
        </div>
        <div class="home-tabs">
          <div class="tabs">
            <div class="tabtitle f-row-c pinter" v-if="(tabsActive == 'news') && ywList&& ywList.length>0"
                 @click="goPage('newDetail', 1, ywList[0].id)">
              {{ $util.overfElli(ywList[0].title, 32) }}
            </div>
            <div class="tabtitle f-row-c pinter" v-if="(tabsActive == 'notice') && jjList&& jjList.length>0"
                 @click="goPage('newDetail', 22, jjList[0].id)">
              {{ $util.overfElli(jjList[0].title, 32) }}
            </div>

            <div class="tabs1 flex">
              <span class="tabs pinter inblock" :class="{ active1: tabsActive === 'news' }"
                    @click="tabsActive = 'news'; goPage('news', tabsActive === 'news' ? 1 : 22);"
                    @mouseover="tabsActive = 'news'">时政要闻</span>
              <span class="tabs pinter inblock" :class="{ active: tabsActive === 'notice' }"
                    @click="tabsActive = 'notice'; goPage('news', tabsActive === 'news' ? 1 : 22);"
                    @mouseover="tabsActive = 'notice'">媒体聚焦</span>
              <!-- <div class="more pinter" @click="goPage('news',tabsActive === 'news'?1:2)">更多&gt;</div> -->
            </div>
            <div class="tabs-cont">
              <ul class="" v-if="tabsActive == 'news'">
                <li v-for="(item, i) in ywList" :key="i" :title="item.title">
                  <span class='poin'></span>
                  <div class="overf-elli item " :title="item.title" @click="goPage('newDetail', tabsActive === 'news' ? 1 : 22, item.id)">
                    {{ item.title ? item.title : '' }}
                  </div>
                </li>
              </ul>
              <ul class="" v-if="tabsActive == 'notice'">
                <li v-for="(item, i) in jjList" :key="i" :title="item.title">
                  <span class='poin'></span>
                  <div class="overf-elli item " :title="item.title" @click="goPage('newDetail', tabsActive === 'news' ? 1 : 22, item.id)">
                    {{ item.title ? item.title : '' }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- banner -->
      <div class="mt-1 lunbotu">
        <div class="SwiperBox" @mouseenter="MouseFun('移入')" @mouseleave="MouseFun('移出')">
          <!-- 图片 -->
          <img :class="['imgCss',ShowImg==index?'ShowCss':'']" @click="toBannerGo(item)"
               :src="item.imgUrl" v-for="(item,index) in imgList" :key="index" :title="item.slideshowName" />
          <!-- 左箭头按钮 -->
          <div class="leftBtn" @click="throttle(PrevFun)">
            <img :src="prevImg"/>
          </div>
          <!-- 右箭头按钮 -->
          <div class="rightBtn" @click="throttle(NextFun)">
            <img :src="nextImg"/>
          </div>

        </div>
<!--        <topbanner v-if='type=="IE"'></topbanner>-->
<!--        <iframe v-else src="./lunbuoBanner/index.html" class="iframebox" ref="utFrame" frameborder="0"></iframe>-->
      </div>
      <!-- 省级团委动态 市级团委动态 县级团委动态 -->
      <div class="f-row-b align-start pl-1 pr-1 mt12">
        <div class="wl">
          <div class="tabs">
            <div class="tabs-header flex bb-1">
							<span :class="tabs === 'provinceDynamicList' ? 'bbact color_red' : ''"
                    @click="tabs = 'provinceDynamicList'" @mouseover="tabs = 'provinceDynamicList'">
								省级团委动态
							</span>
<!--              <div class="lin-y"></div>-->
<!--              <span :class="tabs === 'cityDynamicList' ? 'bbact color_red' : ''" @click="tabs = 'cityDynamicList'"-->
<!--                    @mouseover="tabs = 'cityDynamicList'">-->
<!--								市级团委动态-->
<!--							</span>-->
<!--              <div class="lin-y"></div>-->
<!--              <span :class="tabs === 'countyDynamicList' ? 'bbact color_red' : ''" @click="tabs = 'countyDynamicList'"-->
<!--                    @mouseover="tabs = 'countyDynamicList'">-->
<!--								县级团委动态-->
<!--							</span>-->
<!--              <div class="lin-y"></div>-->
<!--              <span :class="tabs === 'schoolDynamicList' ? 'bbact color_red' : ''" @click="tabs = 'schoolDynamicList'"-->
<!--                    @mouseover="tabs = 'schoolDynamicList'">-->
<!--								高校团委动态-->
<!--							</span>-->
              <div class="more pinter"
                       @click="goPage('news', 8)">

                <!--                   @click="goPage('news', tabs == 'provinceDynamicList' ? 8 : tabs == 'cityDynamicList' ? 9 : tabs == 'countyDynamicList' ? 10 : 31)">-->
                更多&gt;
              </div>
            </div>
            <div class="tabs-cont" v-if='tabsTuanlist'>
              <ul>
                <li v-for="(item, i) in tabsTuanlist[tabs]" :key="i" :title="item.title">
                  <span class='poin'></span>
                  <div class="f-row-b w-100 item"
                       @click="goPage('newDetail', 8, item.id)">
                    <div class="overf-elli title" :title="item.title">{{ item.title ? item.title : '' }}</div>
                    <div class="pl-2 color-gray time">{{ item.createTime | timeFilter }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="wr">
          <div class="tabs">
            <div class="tabs-header flex bb-1">
              <span class="bbact">基层团委动态</span>
              <div class="more pinter" @click="goPage('workNews', 3)">更多&gt;</div>
            </div>
            <div class="tabs-cont">
              <ul>
                <li v-for="(item, i) in finalPublicList" :key="i" :title="item.title">
                  <span class='poin'></span>
                  <div class="f-row-b w-100 item" @click="goPage('newDetail', item.msgType == 6 ? 9 :item.msgType == 7 ? 10 :item.msgType == 25 ? 31 :item.msgType == 101 ? 101 :102, item.id)">
                    <div class="overf-elli title" :title="item.title">{{ item.title ? item.title : '' }}</div>
                    <div class="pl-2 color-gray time">{{ item.createTime | timeFilter }}</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- 专题活动 -->
      <div class="w-100 mt-1 pl-1 pr-1">
        <div class="f-row-b p-r bb-1">
          <div class="bbact">专题活动</div>
          <div class="more pinter" @click="goPage('Events', 15)">更多&gt;</div>
        </div>
        <div class="card-cont">
          <div class="home-activity">
            <div is="actBanner" :list="JSON.stringify(zhuanti)" v-if="zhuanti.length > 0"></div>
          </div>
        </div>
      </div>
<!--      &lt;!&ndash;  学联之窗、少先队工作、创业活动&ndash;&gt;-->
<!--      <div class="f-row-b align-start pl-1 pr-1">-->
<!--        &lt;!&ndash; 学联之窗 &ndash;&gt;-->
<!--        <div style="width:calc(33.33% - 20px)" class="mr-1">-->
<!--          <div class="f-row-b p-r bb-1">-->
<!--            <div class="bbact">学联之窗</div>-->
<!--            <div class="more pinter" @click="goPage('news', 33,)">更多&gt;</div>-->
<!--          </div>-->
<!--          <div class="tabs-cont" v-if='newArr1.length>0'>-->
<!--            <div class="pt08" v-if='newArr1.length>0' :title="newArr1[0].title"-->
<!--                 @click="goPage('newDetail', 33,  item.id)">-->
<!--              <img :src='$imgUrl+ newArr1[0].img' class="w-100 len_img"/>-->
<!--            </div>-->
<!--            <ul style="margin-top:10px">-->
<!--              <li v-if='i>0' v-for="(item, i) in newArr1" :key="i" :title="item.title" @click="goPage('newDetail', 33,  item.id)">-->
<!--                <span class='poin'></span>-->
<!--                <div class="overf-elli item" :title="item.title">-->
<!--                  {{ item.title ? item.title : '' }}-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 少先队工作 &ndash;&gt;-->
<!--        <div style="width:calc(33.33% - 20px)" class="mr-1">-->
<!--          <div class="f-row-b p-r bb-1">-->
<!--            <div class="bbact">少先队工作</div>-->
<!--            <div class="more pinter" @click="goPage('news', 34)">更多&gt;</div>-->
<!--          </div>-->
<!--          <div class="tabs-cont">-->
<!--            <ul class="" v-if='newArr2.length>0'>-->
<!--              <li v-for="(item, i) in newArr2" :key="i" :title="item.title" @click="goPage('newDetail', 34, item.id)">-->
<!--                <span class='poin'></span>-->
<!--                <div class="f-row-b align-start item w-100" :title="item.title">-->
<!--                  <div class="overf-elli w-80">{{ item.title ? item.title : '' }}</div>-->
<!--                  <div>{{ item.createTime|timeFilter }}</div>-->
<!--                </div>-->

<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; 创业活动 &ndash;&gt;-->
<!--        <div style="width:calc(33.33% - 20px)">-->
<!--          <div class="f-row-b p-r bb-1">-->
<!--            <div class="bbact">创业活动</div>-->
<!--            <div class="more pinter" @click="goPage('news', 35)">更多&gt;</div>-->
<!--          </div>-->
<!--          <div class="tabs-cont" v-if='newArr3.length>0'>-->
<!--            <div class="f-row-b align-start w-100 pt08">-->
<!--              <div class="newArr3 bg-gray" v-if='i<=1' v-for="(item, i) in newArr3" :key="i" :title="item.title"-->
<!--                   @click="goPage('newDetail', 35, item.id)">-->
<!--                <img :src='$imgUrl+item.img' class="w-100 len2_img"/>-->
<!--                <div class="p13 font-1 pinter">-->
<!--                  <div class="overf-elli item">{{ item.title || '' }}</div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <ul v-if='newArr3.length>2' style="margin-top:10px">-->
<!--              <li v-if='i>1' v-for="(item, i) in newArr3" :key="i" :title="item.title"-->
<!--                  @click="goPage('newDetail', 35, item.id)">-->
<!--                <span class='poin'></span>-->
<!--                <div class="overf-elli item" :title="item.title">-->
<!--                  {{ item.title ? item.title : '' }}-->
<!--                </div>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 政务平台，工作系统，在线捐助 -->
      <div class="box f-row-b align-start">
        <div class="wl">
          <div class="card-header f-row-l ml-1 bb-1">
            <div class="bbact">服务平台</div>
          </div>
          <div class="w-100">
            <div class="f-row-b wrap pl-1 mt22" v-if="fuwu.length>0">
              <!-- fuwu -->
              <div
                  :class="i == fuwu.length - 1 && (i * 1 + 1) % 2 != 0 ? 'w-100' : 'w-50'"
                  class="pinter"
                  v-for="(item, i) in fuwu"
                  :key="i"
                  @click="openUrl(item.subLink)"
              >
                <div
                    class="fastlink-item "
                    :class="i == fuwu.length - 1 && (i * 1 + 1) % 2 != 0 ? 'f-row-c' : 'f-row-l'"
                    :style="{ background: iconList[i - Math.floor(i / 9) * 9].color }"
                >
                  <div class="fastlink-icon imgbox"><img :src="host + '/' + item.subIcon"/></div>
                  <span class="overf-elli txt" :title="item.subName">{{ item.subName ? item.subName : '' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wr">
          <div class="card-header f-row-l bb-1 ml-1 mr-1">
            <div class="bbact">在线捐助</div>
          </div>
          <div class="card-cont ml-1 mt22">
            <div class="home-donation">
              <ul v-if='donationList.length>0'>
                <li
                    v-for="(item, i) in donationList"
                    :key="i"
                    class="item mr-1 pinter"
                    :style="{ display: i < 2 ? '' : 'none' }"
                    :class="i != 0 ? 'mt-6 bt-1' : ''"
                    @click="openOtherPro(item)"
                >
                  <div class="itemimg" v-if="i == 0">
                    <div class="tip" v-if="item.state == '0'"><img :src="require('@/assets/img/index/type.png')"/></div>
                    <img class="bgimg"
                        :src="item.indexPic ? $apiUrlXW + 'sys/common/static/' + item.indexPic : require('@/assets/img/donation.png')"/>
                  </div>
                  <div :class="i == 0 ? 'pl-1' : 'pr-1'" class="conbox">
                    <div class="font-w">{{ item.title ? item.title : '' }}</div>
                    <div class="cont">
                      <div>执行机构：{{ item.reciveDept ? item.reciveDept : '' }}</div>
                      <div>
                        资助时间：{{ item.startDate ? item.startDate : '' }}
                        <!-- -{{item.endDate}} -->
                      </div>
                      <div>资助地点：{{ item.contributionFlow ? item.contributionFlow : '' }}</div>
                    </div>
                  </div>
                  <div class="itemimg" v-if="i == 1">
                    <div class="tip" v-if="item.state == '0'"><img :src="require('@/assets/img/index/type.png')"/></div>
                    <img class="bgimg" :src="encodeURI(item.indexPic ? $apiUrlXW + 'sys/common/static/' + item.indexPic : require('@/assets/img/donation.png')).replace('.webp','.jpg')"/>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- 精彩图集 v-if='phoneLength'-->
<!--      <div class="w-100">-->
<!--        <div class="f-row-b p-r mt-2 ml-1 mr-1 bb-1">-->
<!--          <div class="card-header f-row-l">-->
<!--            <div class="bbact">精彩图集</div>-->
<!--          </div>-->
<!--          <div class="more pinter" @click="goPage('/phoneBooksList', 7)">更多&gt;</div>-->
<!--        </div>-->
<!--        <div class="home-photos">-->
<!--          <phoneBooks is_index='1' @phoneLen='phoneLen'></phoneBooks>-->
<!--        </div>-->
<!--      </div>-->
      <!-- 优秀五四青年 优秀团干部 全省共青团组织 全省共青团员-->
<!--      <div class="f-row-b align-start mt-1">-->
<!--        <div class="wl">-->
<!--          <div class="home-tabs">-->
<!--            <div class="tabs">-->
<!--              <div class="tabs1 flex">-->
<!--								<span-->
<!--                    class="tabs pinter inblock"-->
<!--                    :class="{ active2: tabsAct === 'youthList' }"-->
<!--                    @click="-->
<!--										tabsAct = 'youthList';-->
<!--										goPage('news', tabsAct == 'youthList' ? 12 : 13);-->
<!--									"-->
<!--                    @mouseover="tabsAct = 'youthList'"-->
<!--                >-->
<!--									优秀五四青年-->
<!--								</span>-->
<!--                <span-->
<!--                    class="tabs pinter inblock"-->
<!--                    :class="{ active3: tabsAct === 'cadreList' }"-->
<!--                    @click="-->
<!--										tabsAct = 'cadreList';-->
<!--										goPage('news', tabsAct == 'youthList' ? 12 : 13);-->
<!--									"-->
<!--                    @mouseover="tabsAct = 'cadreList'"-->
<!--                >-->
<!--									优秀团干部-->
<!--								</span>-->
<!--                &lt;!&ndash; <div class="more pinter" @click="goPage('news',tabsAct === 'youthList'?12:13)">更多&gt;</div> &ndash;&gt;-->
<!--              </div>-->
<!--              <div class="tabs-cont mt-2">-->
<!--                <div v-if='tabsTopYouth[tabsAct].length>0' v-for="(item, i) in tabsTopYouth[tabsAct]" :key="i"-->
<!--                     class="f-row-l align-start headli" :style="{ display: i < 3 ? '' : 'none' }">-->
<!--                  <div class="headbox f-row-c"><img-->
<!--                      :src="item.memberImg ? $imgUrl + item.memberImg : '../../assets/img/photo1.png'"/></div>-->
<!--                  <div class="txt" :title="item.memberName ? item.memberName : ''"-->
<!--                       @click="goPage('newDetail', tabsAct === 'youthList' ? 12 : 13, item.id)">-->
<!--                    <div class="font-w">{{ item.memberName ? item.memberName : '' }}</div>-->
<!--                    <div :title="$util.overfElli(item.memberIntroduce ? item.memberIntroduce : '暂无介绍', 50)">-->
<!--                      {{ $util.overfElli(item.memberIntroduce ? item.memberIntroduce : '暂无介绍', 50) }}-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="wr pr-1">-->
<!--          <div class="tabs pl-1 bg-gray">-->
<!--            <div class="tabs-header f-row-c">-->
<!--							<span-->
<!--                  :class="{ bbact: tabsActChart === 'orgNumberList' }"-->
<!--                  @click="tabsActChart = 'orgNumberList'"-->
<!--                  @mouseover="-->
<!--									tabsActChart = 'orgNumberList';-->
<!--									$refs.child.onrest();-->
<!--								"-->
<!--              >-->
<!--								全省共青团组织-->
<!--							</span>-->
<!--              <div class="lin-y"></div>-->
<!--              <span-->
<!--                  :class="{ bbact: tabsActChart === 'numberList' }"-->
<!--                  @click="tabsActChart = 'numberList'"-->
<!--                  @mouseover="-->
<!--									tabsActChart = 'numberList';-->
<!--									$refs.child.onrest();-->
<!--								"-->
<!--              >-->
<!--								全省共青团员-->
<!--							</span>-->
<!--            </div>-->
<!--            <div class="chart1" v-if="tabsActChart === 'orgNumberList'">-->
<!--              <div-->
<!--                  is="echartR"-->
<!--                  ref="child"-->
<!--                  v-if="isRouterAlive"-->
<!--                  :option="tabsNum[tabsActChart]"-->
<!--                  :title="tabsActChart === 'orgNumberList' ? '共青团组织' : '共青团员'"-->
<!--              ></div>-->
<!--            </div>-->
<!--            <div class="chart1" v-if="tabsActChart === 'numberList'">-->
<!--              <div-->
<!--                  is="echartR"-->
<!--                  ref="child"-->
<!--                  v-if="isRouterAlive"-->
<!--                  :option="tabsNum[tabsActChart]"-->
<!--                  :title="tabsActChart === 'orgNumberList' ? '共青团组织' : '共青团员'"-->
<!--              ></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="w-100 f-row-b align-start mt12">
        <div class="w-100 pl-1">
          <div class="card-header f-row-l bb-1">
            <div class="bbact">友情链接</div>
            <div></div>
          </div>
          <div class="card-cont">
            <div class="home-links">
              <a class='inblock' :href="item.blogrollSite" target="_blank" v-for="(item, i) in lianjie" :key="i"
                 :title="item.blogrollName">
                <span class="overf-elli text-p f-row-c inblock"
                      :title="item.blogrollName">{{ item.blogrollName ? item.blogrollName : '' }}</span>
              </a>
            </div>
          </div>
        </div>
<!--        <div class="wr">-->
<!--          <div class="card-header f-row-l ml-1 bb-1">-->
<!--            <div class="bbact">APP下载</div>-->
<!--          </div>-->
<!--          <div class="card-cont">-->
<!--            <div class="home-links app">-->
<!--              <a href="#" target="_blank" class="app" v-for="(item, j) in xietong" :key="j"-->
<!--                 @click="openUrl(item.subLink)">-->
<!--                <div class="home-links-tag"><img :src="item.subIcon?(host + '/' + item.subIcon):defaultImg"/></div>-->
<!--                <span class="overf-elli" :title="item.subName">{{ item.subName ? item.subName : '' }}</span>-->
<!--              </a>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {announce, information, queryHomeData} from '@/axios/api';
import actBanner from '@/components/banner/actBanner.vue';
import banner from '@/components/banner/banner.vue';
import echartR from '@/components/echart/echart.vue';
import topbanner from '@/components/banner/topbanner.vue';

export default {
  components: {actBanner, banner, echartR,topbanner},
  name: 'Home',
  provide() {
    return {
      reload: this.reload
    };
  },
  filters: {
    timeFilter(val) {
      var time = '';
      if (!val) {
        return time;
      }

      if (val) {
        var dataArr = val.split(' ')[0].split('-');
        time = dataArr[1] + '-' + dataArr[2];
      }
      return time;
    }
  },
  data() {
    var self = this;
    return {
      defaultImg: require('../../assets/img/icon10.png'),
      prevImg: require('../../assets/img/index/prev.png'),
      nextImg: require('../../assets/img/index/next.png'),
      pageshow: false,
      isRouterAlive: true,
      iconList: [
        {
          src: require('@/assets/img/index/icon1.png'),
          color: '#8BDD98'
        },
        {
          src: require('@/assets/img/index/icon2.png'),
          color: '#5ECBB5'
        },
        {
          src: require('@/assets/img/index/icon3.png'),
          color: '#F4CE91'
        },
        {
          src: require('@/assets/img/index/icon4.png'),
          color: '#9BBAE3'
        },
        {
          src: require('@/assets/img/index/icon5.png'),
          color: '#6AC2E2'
        },
        {
          src: require('@/assets/img/index/icon6.png'),
          color: '#E17F6E'
        },
        {
          src: require('@/assets/img/index/icon7.png'),
          color: '#09A8C5'
        },
        {
          src: require('@/assets/img/index/icon8.png'),
          color: '#AC99BE'
        },
        {
          src: require('@/assets/img/index/icon9.png'),
          color: '#ECB570'
        }
      ],
      host: self.$imgUrl,
      ywList:[],
      jjList:[],
      zhuanti: {},
      tuji: {},
      lianjie: {},
      xietong: {},
      fuwu: {},
      xitong: {},
      lunbo: {},
      tabsActive: 'news',
      tabs: 'provinceDynamicList',
      tabsAct: 'youthList',
      tabsActChart: 'orgNumberList',
      tabsList: {
        news: [],
        notice: []
      },
      tabsTuanlist: {
        provinceDynamicList: [], //省
        cityDynamicList: [], //市
        countyDynamicList: [], //县
        schoolDynamicList: [] // 高校
      },
      tabsTopYouth: {
        youthList: [], //优秀五四青年
        cadreList: [] //优秀团干
      },
      tabsNum: {
        orgNumberList: [], //团组织
        numberList: [] //团员
      },
      finalPublicList: [], //基层团委动态

      donationList: [],

      newArr1: [],
      newArr2: [],
      newArr3: [],
      phoneLength: 0,
      phoneTip: false,
      type:'',
      showFloatingInspection: true,
      inspectionTimer: null,
      inspectionX: 0,
      inspectionY: 120,
      inspectionXDirection: 1,
      inspectionYDirection: 1,
      inspectionXSpeed: 1.3,
      inspectionYSpeed: 0.8,

      imgList: [],
      ShowImg:0,  // 表示当前显示的图片
      flag:true, // 用来节流防止重复点击
      start:null, // 自动执行下一张定时器

    };
  },
  created() {
    if (window.performance.navigation.type === 1) {
      console.log('页面被刷新');
    } else {
      console.log('页面首次被加载');
    }
    this.announce();
    this.queryHomeData();
    this.getDonateList();
    // this.getNewArr1()
    // this.getNewArr2()
    // this.getNewArr3()
    this.getActivity();

    this.type=this.$util.browserType()
  },
  mounted() {
    this.startInspectionFloat();
  },
  beforeDestroy() {
    this.stopInspectionFloat();
  },
  methods: {
    startInspectionFloat() {
      if (this.inspectionTimer) {
        return;
      }
      this.inspectionTimer = setInterval(this.moveInspectionFloat, 30);
    },
    stopInspectionFloat() {
      if (this.inspectionTimer) {
        clearInterval(this.inspectionTimer);
        this.inspectionTimer = null;
      }
    },
    closeInspectionFloat() {
      this.showFloatingInspection = false;
      this.stopInspectionFloat();
    },
    moveInspectionFloat() {
      var el = this.$refs.inspectionFloat;
      if (!el) {
        return;
      }
      var maxX = Math.max(0, window.innerWidth - el.offsetWidth);
      var maxY = Math.max(0, window.innerHeight - el.offsetHeight);

      this.inspectionX += this.inspectionXSpeed * this.inspectionXDirection;
      this.inspectionY += this.inspectionYSpeed * this.inspectionYDirection;

      if (this.inspectionX <= 0 || this.inspectionX >= maxX) {
        this.inspectionX = Math.min(Math.max(this.inspectionX, 0), maxX);
        this.inspectionXDirection *= -1;
      }
      if (this.inspectionY <= 0 || this.inspectionY >= maxY) {
        this.inspectionY = Math.min(Math.max(this.inspectionY, 0), maxY);
        this.inspectionYDirection *= -1;
      }
    },
    onPhoneShow() {
      this.phoneTip = true;
      this.$nextTick(() => {
        this.phoneTip = false
      });
    },
    phoneLen(e) {
      this.phoneLength = e
    },
    getNewArr1() {
      this.newArr1 = []
      var param = {
        pageNo: 1,//分页
        pageSize: 4,
        msgType: 40,
        recommendHome:0,
      }
      this.$get('/web/home/queryInfoList', param).then(res => {
        this.newArr1 = res.result.records;
      })

    },
    getNewArr2() {
      this.newArr2 = []
      var param = {
        pageNo: 1,//分页
        pageSize: 9,
        msgType: 41,
        recommendHome:0,
      }
      this.$get('/web/home/queryInfoList', param).then(res => {
        this.newArr2 = res.result.records;
      })

    },
    getNewArr3() {
      this.newArr3 = []
      var param = {
        pageNo: 1,//分页
        pageSize: 5,
        msgType: 42,
        recommendHome:0,
      }
      this.$get('/web/home/queryInfoList', param).then(res => {
        this.newArr3 = res.result.records;
      })

    },
    openOtherPro(item) {
      var url = this.$openUrlXW + item.id;
      this.openUrl(url);
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    openUrl(url) {
      window.open(url);
    },
    goPage(url, type, id) {
      this.$util.goTop();
      var val = type ? url + '?type=' + type : url;
      this.$parent.changeIndex(val); //调用父级方法
      var params = {};
      if (type) {
        params.type = type;
      }
      if (id) {
        params.id = id;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    announce() {
      var param = {
        pageNo: 1,
        pageSize: 7,
        recommendHome:0,
      };
      announce(param).then(res => {
        console.log('announce', 1);
        this.jjList = res.result.records;
      });
      information(param).then(res => {
        console.log('information', 2);
        this.ywList = res.result.records;
      });
    },
    getActivity() {
      var param = {
        pageNo: 1,
        pageSize: 8
      }
      this.$get('/web/home/newActList', param).then(res => {
        this.zhuanti = res.result.records;
      })
    },
    queryHomeData() {
      queryHomeData().then(res => {
        console.log('queryHomeData', 3);
        this.pageshow = true;
        var slideshowTwoList=res.result.slideshowTwoList?res.result.slideshowTwoList:[]
        if(slideshowTwoList.length>0){
          for(var i=0;i<slideshowTwoList.length;i++){
            let imageUrl = {};
            imageUrl.imgUrl = this.$imgUrl+slideshowTwoList[i].slideshowImg;
            imageUrl.slideshowName = slideshowTwoList[i].slideshowName || '';
            imageUrl.slideshowLink = slideshowTwoList[i].slideshowLink || '';

            this.imgList.push(imageUrl);
          }

          this.setTimeoFun();
        }

        // this.zhuanti = res.result.activityList;
        this.tuji = res.result.atlasList;
        this.lianjie = res.result.blogrollList;
        this.xietong = res.result.appList;
        this.fuwu = res.result.serviceList;
        this.xitong = res.result.sysWorkList;
        this.lunbo = res.result.slideshowList;

        this.tabsTuanlist = {
          provinceDynamicList: res.result.provinceDynamicList, //省
          cityDynamicList: res.result.cityDynamicList, //市
          countyDynamicList: res.result.countyDynamicList, //县
          schoolDynamicList: res.result.schoolDynamicList // 高校
        };
        // this.tabsTopYouth = {
        //   youthList: res.result.youthList, //优秀五四青年
        //   cadreList: res.result.cadreList //优秀团干
        // };
        // this.tabsNum = {
        //   orgNumberList: res.result.orgNumberList, //团组织
        //   numberList: res.result.numberList //团员
        // };
        this.finalPublicList = res.result.finalPublicList; //基层团委动态
      });
    },
    getDonateList() {
      this.$axios.get(this.$apiUrlXW + 'web/thpDonationActivity/queryPageList').then(res => {
        if (res.success) {
          console.log('getDonateList', 4);
          this.donationList = res.result.records;
        }
      });
    },

    // 这里定义一个鼠标移入移出事件，鼠标悬停时停止自动轮播，鼠标移出则重新执行自动轮播
    MouseFun(type){// 停止定时器            // 重新执行定时器
      type=='移入'?clearTimeout(this.start):this.setTimeoFun()
    },
    setTimeoFun(){
      this.start = setInterval(()=>{
        this.NextFun()
      },3000)
    },
    // 这里通过额外封装的节流函数触发 PrevFun() 和 NextFun(),以达到防止重复点击的效果
    throttle(fun) {
      if (this.flag) {
        this.flag = false;
        fun(); // 此为模板中传递进来的PrevFun()或NextFun()函数
        setTimeout(() => {
          this.flag = true;
        }, 1200); // 节流间隔时间
      }
    },
    // 上一张
    PrevFun(){
      if(this.ShowImg!==0){
        this.ShowImg--
      }else{
        this.ShowImg=this.imgList.length-1
      }
    },
    // 下一张
    NextFun() {
      if (this.ShowImg !== this.imgList.length - 1) {
        this.ShowImg++
      } else {
        this.ShowImg = 0
      }
    },
    toBannerGo(item){
      if(item && item.slideshowLink){
        window.open(item.slideshowLink)
      }


    },
  }
};
</script>

<style lang="scss">
[v-cloak] {
  display: none;
}
.main-in1{
  min-height: 1000px;
}
.iframebox{
  width: 100%;
  height: 100%;
  margin-left: 10px;
}
.color_red {
  color: #ba0711;
}

.home {
  font-size: 16px;

  &-floating-inspection {
    position: fixed;
    width: 130px;
    z-index: 20;
    pointer-events: none;

    &-img {
      display: block;
      width: 100%;
      height: 195px;
    }

    &-close {
      position: absolute;
      top: -9px;
      right: -9px;
      width: 20px;
      height: 20px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.62);
      cursor: pointer;
      font-size: 16px;
      line-height: 20px;
      text-align: center;
      pointer-events: auto;
    }
  }

  &-tabs {
    width: 550px;
    padding-left: 20px;
  }

  &-row {
    & + & {
      margin-left: 10px;
    }
  }

  &-donation {
    .item {
      min-height: 193px;
    }

    ul {
      padding: 0;
      margin: 0;

      li {
        height: 48px;
        list-style: none;
        display: flex;
        align-items: center;

        .itemimg {
          margin-top: 30px;
          width: 320px;
          height: 193px;
          position: relative;
          overflow: hidden;


          .tip {
            position: absolute;
            top: 0;
            left: 12px;
            width: 44px;
            height: 55px;
            overflow: hidden;

            img {
              width: 100%;
            }
          }

          img {
            max-width: 320px;
            max-height: 193px;
          }
        }

        .conbox {
          width: calc(100% - 320px);

          .font-w {
            font-weight: bold;
          }

          .cont {
            margin-top: 30px;
            font-size: 14px;
            color: #666666;
          }
        }
      }
    }
  }

  &-photos {
    padding: 17px 5px;
  }

  &-links {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    justify-content: flex-start;
    padding: 10px;

    &.app {
      min-height: 100px;
    }

    & > a {
      // width: 30%;
      min-width: 180px;
      padding-right: 30px;
      line-height: 40px;

      &.app {
        display: flex;
        align-items: center;
      }
    }

    &-tag {
      width: 36px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      color: #fff;
      background-color: #e81414;
      border-radius: 5px;
      font-size: 14px;
      margin-right: 5px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .hover-box:hover {
    .imgbox {
      transform: translateY(-10px);
    }

    .txt {
      transform: scale(1.2);
    }
  }
}

.flex {
  display: flex;
  align-items: center;
}

.swiper {
  width: 630px;
  height: 430px;
}

.wl {
  width: 630px;
  padding-right: 10px;

  .home-tabs {
    width: 630px;
    padding-left: 10px;
    padding-right: 10px;
  }
}

.wr {
  width: calc(100% - 630px);
  padding-left: 10px;
  height: auto;

  .bg-gray {
    background: #f1f1f1;
  }

  .chart1 {
    margin: auto;
    width: 100%;
    height: 354px;
  }
}

.len2_img {
  width: 176px;
  height: 119px;
}

.len_img {
  width: 370px;
  height: 207px;
}

.tabs {
  width: 100%;

  .tabtitle {
    height: 78px;
    font-size: 28px;
    line-height: 35px;
    margin: 20px auto;
    color: #ba0711;
    font-weight: 800;
  }

  &-header {
    position: relative;
    height: 47px;
    line-height: 48px;

    & > span {
      display: block;
      margin-right: 10px;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
      font-weight: bold;
    }

    & > .lin-y {
      width: 2px;
      height: 14px;
      background: #f1f1f1;
      margin: 0px 15px;
    }
  }

  .mt-2 {
    margin-top: 24px;
  }

  &-cont {
    margin-top: 12px;

    .title {
      width: calc(100% - 70px);
    }

    .time {
      width: 70px;
    }

    .headli {
      margin-bottom: 35px;

      .headbox {
        width: 80px;
        height: 80px;
        overflow: hidden;
        margin-right: 10px;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      .txt {
        width: calc(100% - 90px);

        .font-w {
          font-weight: 600;
          margin-bottom: 10px;
        }
      }
    }

    .headli:hover {
      .txt:hover {
        cursor: pointer;
        color: #ba0711;

        .color-gray {
          color: #ba0711;
        }
      }
    }

    ul {
      margin: 0;
      padding-left: 20px;
      margin-top: 12px;

      li {
        line-height: 38px;
        color: #ba0711;

        .item {
          color: #666666;

          .color-gray {
            color: #666666;
          }
        }

        .item:hover {
          cursor: pointer;
          color: #ba0711;

          .color-gray {
            color: #ba0711;
          }
        }
      }
    }
  }
}

.tabs1 {
  width: 100%;
  height: 44px;
  line-height: 44px;
  text-align: center;
  background: #f1f1f1;
  overflow: hidden;
  @keyframes moveright {
    from {
      left: -100%;
    }
    to {
      left: 0px;
    }
  }
  @keyframes moveleft {
    from {
      left: 100%;
    }
    to {
      left: 0px;
    }
  }

  .tabs {
    font-size: 18px;
    font-weight: bold;
    width: 50%;
  }


  .active,
  .active1,
  .active2,
  .active3 {
    position: relative;
  }

  .active::after,
  .active1::after,
  .active2::after,
  .active3::after {
    width: 100%;
    height: 100%;
    background: #ba0711;
    position: absolute;
    z-index: 0;
    bottom: 0px;
    left: 0;
    color: #fff;
    font-weight: bold;
    border-radius: 5px;
  }

  .active::after {
    content: '媒体聚焦';
    animation: moveright 1s 1;
  }

  .active1::after {
    content: '时政要闻';
    animation: moveleft 1s 1;
  }

  .active2::after {
    content: '优秀五四青年';
    animation: moveleft 1s 1;
  }

  .active3::after {
    content: '优秀团干部';
    animation: moveright 1s 1;
  }
}

.fastlink-item {
  height: 86.8px;
  color: #ffffff;
  width: calc(100% - 4px);
  margin-bottom: 4px;
  border-radius: 5px;
  box-sizing: border-box;
  padding-left: 50px;
  padding-right: 30px;
  font-weight: bold;
}

.fastlink-icon {
  width: 36px;
  height: 36px;
  overflow: hidden;
  margin-right: 10px;

  img {
    width: 100%;
  }
}

.fastlink-item:hover {
  transform: translateY(-10px);
  box-shadow: 5px 5px 8px rgba(0, 0, 0, 0.3);

  .fastlink-icon {
    transform: scale(1.2);
  }
}

.home-links {
  .text-p {
    min-height: 80px;
    display: flex;
    align-content: flex-start;
    justify-content: left;
  }
  span {
    font-size: 16px;
  }
}

.home-links > a {
  min-width: 145px;
  padding-right: 30px;
  line-height: 40px;
}

.more {
  position: absolute;
  line-height: 1;
  top: 17px;
  right: 10px;
  font-size: 14px;
  color: #ba0711;
  display: inline-block;
}

.newArr3 {
  width: calc(50% - 10px);

  .p13 {
    padding: 15px 13px 21px;
    box-sizing: border-box;
  }
}

.bg-gray {
  background: #F6F6F6;
}
.inblock{
  display: inline-block;
}


.lunbotu{
  /* 图片容器样式 */
  .SwiperBox {
    position: relative;
    width: 99%;
    height: 140px;
    box-sizing: border-box;
    cursor: pointer;
    margin-left: 10px;
  }
  /* 图片默认样式 */
  .imgCss {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 140px;
    opacity: 0;
    transition: 1.8s;  /* 淡入淡出过渡时间 */
    display: none;
  }
  /* 图片选中样式(继承上方默认样式) */
  .ShowCss {
    opacity: 1;
    display:block;
  }
  /* 两个按钮共有的样式,也可直接使用箭头图片替代 */
  .leftBtn,
  .rightBtn {
    position: absolute;
    top: 35%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .leftBtn {
    left: 10px;
  }
  .rightBtn {
    right: 10px;
  }
  /* 下方指示器盒子 */
  .instBox{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    display: flex;
  }
  /* 小圆点 */
  .inst{
    width: 10px;
    height: 10px;
    border: 1px solid #ccc;
    margin-right: 8px;
    background: #fff;
    border-radius: 50%;
    cursor: pointer;
  }
  .inst:last-child{
    margin-right: 0px;
  }
  .instActv{
    border: 1px solid #ff0000;
    background: #ff0000;
  }
  #app{
    width: 100%;
    padding: 120px;
    display: flex;
    justify-content: center;
  }

}
</style>
